module.exports = __webpack_public_path__ + "img/ic_export_16.510cea74.svg";